import {useState} from 'react'

function Joblist({job}){
  /* implementing for read more button */
  const [readMore,setReadMore]=useState(false);

  const toggleExpand = ()=>{
    setReadMore(prev=>!prev)
    console.log(job)
  }


  return(
    <div className="joblist__job">
      <h2 className="job__name">{job.Name}</h2>
      <h3 className="job__company">{job.company_name}  &emsp; {job.location}</h3>
      <div className="job__description">
        <p>Jobs Description and Detail</p>
        {readMore? <p>{job.description}</p>:
          <p>{`${job.description.substring(0, 100)}...`}</p>
        }
      </div>
      <button className="btn--expand" onClick={toggleExpand}>{readMore? 'collapse': '+ Expand'}</button>
      <div className="job__footer">
        <button className="job__button" onClick={() => window.location = `/apply/${job._id}`}>Apply</button>
      </div>
    </div>
  )
}

export default Joblist
